export default __webpack_public_path__ + "static/media/einvoice.58e14147.svg";